import { ERROR_MESSAGES, FIELDS, IFamilyGroupError } from "../../../Interfaces/IFamilyGroupFormField";
import { IValidationRules } from "../../../Interfaces/IValidationRule";
import { IFamilyGroupFormValueType } from "../../../Types/familyGroupFormProps";

const IsNullEmptyUndefined = (value: any) => {
  if (typeof value === "string") {
    return value?.trim() === "";
  }

  return value === undefined || value === null;
}


const required = (
  value: any,
  formValues: any,
  field: any,
  ruleConfig?: any | undefined
) => {
  const isValid = !IsNullEmptyUndefined(value);
  return {
    valid: isValid,
    errorMessage: isValid ? "" : ERROR_MESSAGES.required,
  };
};

/*Validations*/
/*Rules*/
const rules = {
  required
};


export const validateField = (field: string, value: any, formValues: any) => {
  let result = true;
  const errors = { [field]: "" };
  Object.keys(FIELDS[field as keyof typeof FIELDS].rules).forEach(
    (rule) => {

      if (!result) {
        return;
      }

      const fieldResult = rules[rule as keyof typeof rules](
        value,
        formValues,
        field,
        (FIELDS[field as keyof typeof FIELDS]?.rules as IValidationRules)?.[rule as keyof typeof rules]
      );

      if (!fieldResult.valid) {
        result = false;
        errors[field] = fieldResult?.errorMessage;
      }
    }
  );

  return { result, errors };
};

export const validateForm = (values: IFamilyGroupFormValueType) => {
  let result = true;
  const errors: IFamilyGroupError = {
    FamilyGroup: undefined,
    BusinessUnit: undefined,
    SuperCategory: undefined,
    Category: undefined,
    SubCategory: undefined,
    Segment: undefined,
    ProductCount: undefined,
    UpdatedDate: undefined,
    UpdatedBy: undefined,
    CreatedDate: undefined,
    FamilyGroupNew: undefined,
    Company: undefined,
    SuperCatDesc: undefined,
    SubCategoryDesc: undefined,
    CategoryDesc: undefined,
    BusinessUnitDesc: undefined,
    SegmentDesc: undefined,
    ProductType: undefined,
  };

  Object.keys(FIELDS).forEach((field) => {
    const fieldResult = validateField(
      field,
      values[field as keyof typeof FIELDS],
      values,
    );

    if (!fieldResult.result) {
      result = false;
      errors[field as keyof typeof FIELDS] = fieldResult.errors[field];
    }

  });
  return { result, errors };
};